import {CategoryGeneratorHelper} from "../../common/utils/categoryGenerator.helper";
import {Stack, Typography, useTheme} from "@mui/material";
import React from "react";
import {QuizType} from "../../common/enums/quizType.enum";

interface Props {
    title: string;
    quizType?: QuizType;
}

const CategoryTitle = ({ title, quizType } : Props) => {
    
    const theme = useTheme();
    
    return <Stack
        flexDirection={"row"}
        paddingBottom={4}
    >
        {CategoryGeneratorHelper.getCategoryIcon(theme, quizType)}
        <Typography
            variant="subtitle1"
            fontWeight={"bold"}
            color={theme.palette.thatsMe.textTitle}
            marginLeft={1}
        >
            {title}
        </Typography>
    </Stack>;
};

export default CategoryTitle;